import {isEmpty} from 'lodash';
import PropertyDetailImages from './PropertyDetailImages';

const selectedImage = (state) => {
  const {
    coverPageImages: {large, selections},
    reportType: {value: reportType}
  } = state;

  let selection = selections[reportType] || {
    imageUri: isEmpty(large) ? PropertyDetailImages.list(state.propertyDetail)[0] : large[0].image,
    type: isEmpty(large) ? 'property' : 'lifestyle',
  };
  if (selection.imageUri === 'default') {
    if (selection.type === 'property') {
      selection.imageUri = PropertyDetailImages.list(state.propertyDetail)[0];
    } else {
      selection.imageUri = null;
    }
  }

  return {
    src: selection.imageUri,
    type: selection.type,
    zoom: selection.zoom || 1.0,
    x: selection.x ?? null,
    y: selection.y ?? null,
  };
};

const typeToLayout = {
  'lifestyle': 'large',
  'property': 'half',
};

const CoverImagesLib = {
  selectedImage,
  shouldCropCoverImage: (state, layout = typeToLayout[selectedImage(state).type], imageUri = selectedImage(state).src) => {
    return layout === 'large' &&
      state.coverPageImages.large
      .filter(c => (c.image === imageUri || c.thumbnail === imageUri) && c.franchise)
      .length === 1;
  }
};
export default CoverImagesLib;
